// ── Viagem Tab ───────────────────────────────────────────────────────────────
import { getTrip, getState }    from '@/store/tripState';
import { saveTrip }             from '@/services/sync.service';
import { toArr, initials,
         avatarColor, sanitize } from '@/helpers';
import { ref, get }             from 'firebase/database';
import { db }                   from '@/firebase';
import type { Trip, Traveler }  from '@/types';

export function renderTripSettings(): void {
  const trip = getTrip();
  const ni   = document.getElementById('trip-name-inp') as HTMLInputElement;
  const si   = document.getElementById('trip-start-inp') as HTMLInputElement;
  const ei   = document.getElementById('trip-end-inp') as HTMLInputElement;
  if (ni && document.activeElement !== ni) ni.value = trip.name ?? '';
  if (si) si.value = trip.start ?? '';
  if (ei) ei.value = trip.end ?? '';

  const el  = document.getElementById('travelers-list');
  if (!el) return;
  const arr = toArr(trip.travelers ?? {}) as Traveler[];
  arr.sort((a, b) => (a.name??'').localeCompare(b.name??'', 'pt-BR'));
  if (!arr.length) { el.innerHTML = '<div class="empty">Nenhum viajante.</div>'; return; }
  const { isAdmin, currentUser } = getState();
  el.innerHTML = arr.map((tr, i) => {
    const canRemove = isAdmin || !tr.uid || tr.uid === currentUser?.uid;
    return `
    <div class="user-row">
      <div class="user-avatar" style="background:${avatarColor(i)};color:#fff">${initials(tr.name)}</div>
      <div class="user-info">
        <div class="user-name">${sanitize(tr.name)}</div>
        ${tr.email ? `<div class="user-email">${sanitize(tr.email)}</div>` : ''}
      </div>
      ${canRemove ? `<button class="icon-btn del" onclick="window.__delItem('travelers','${tr.id}')">×</button>` : ''}
    </div>`;
  }).join('');
}

export function saveTripField(field: keyof Trip, value: unknown): void {
  if (field === 'start' || field === 'end') {
    const trip  = getTrip();
    const start = field === 'start' ? String(value) : (trip.start ?? '');
    const end   = field === 'end'   ? String(value) : (trip.end   ?? '');
    if (start && end && end < start) {
      import('@/ui/toast').then(({ toastError }) => toastError('A data de fim deve ser posterior à data de início.'));
      return;
    }
  }
  saveTrip(field as string, value).catch(() => void 0);
  if (field === 'name') {
    const nt = document.getElementById('nav-trip-title');
    if (nt) nt.textContent = (getTrip().emoji ?? '✈️') + ' ' + String(value);
  }
}

export function getTravelerOptions(selectedId: string): string {
  const sorted = toArr(getTrip().travelers ?? {})
    .sort((a, b) => (a.name??'').localeCompare(b.name??'', 'pt-BR'));
  return `<option value="">— Selecionar —</option>` +
    sorted.map(tr =>
      `<option value="${tr.id}" ${tr.id === selectedId ? 'selected' : ''} >${sanitize(tr.name)}</option>`
    ).join('');
}

export function getPayerName(payerId: string): string {
  const tr = getTrip().travelers?.[payerId];
  return tr?.name ?? '';
}

export async function autoFillTravelerName(select: HTMLSelectElement): Promise<void> {
  const linkedUid = select.value;
  if (!linkedUid) return;
  try {
    const snap = await get(ref(db, `users/${linkedUid}`));
    const u    = snap.val() as {displayName?: string; email?: string} | null;
    if (!u) return;
    const nameInp = document.getElementById('f-name') as HTMLInputElement;
    if (nameInp) nameInp.value = u.displayName ?? u.email ?? '';
  } catch { /* silently ignore */ }
}
